import themePages from './theme-pages.json';
import siteOverrides from './pages.json';

interface NavPageEntry {
  name?: string;
  path?: string;
  position?: number;
  visible?: boolean;
  template?: string;
  parent?: string;
  noindex?: boolean;
}

function mergeNavPages(
  base: Record<string, NavPageEntry>,
  overrides: Record<string, NavPageEntry>,
): Record<string, NavPageEntry> {
  const merged: Record<string, NavPageEntry> = { ...base };
  for (const [alias, patch] of Object.entries(overrides)) {
    merged[alias] = { ...merged[alias], ...patch };
  }
  return merged;
}

const pagesData = mergeNavPages(
  themePages as Record<string, NavPageEntry>,
  siteOverrides as Record<string, NavPageEntry>,
);

export default pagesData;
